var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stepCardWrapper"},[_c('div',{staticClass:"stepImage"},[_c('img',{attrs:{"src":require(`@/${_vm.imageSource}`),"alt":""}})]),_c('div',{staticClass:"stepCardContent"},[_c('p',{staticClass:"stepTitle"},[_vm._v(_vm._s(_vm.stepTitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }